<template>
  <article>
    <job-preview-content-outline
      title="仕事内容"
      data-test="job"
      v-on="$listeners"
    >
      <job-preview-content
        :comment-highlights="getAnyCommentHighlights(targetIdMap.description.job.prefix)"
        :text-count-mode="textCountMode"
        :highlight-mode="highlightMode"
        :text-counts="textCounts.job"
        :target-id="targetIdMap.description.job.detail"
        :value="description.detail"
        data-test="job-content"
        v-on="$listeners"
      >
        <template
          v-if="description.catchCopy"
          #catch
        >
          <p
            :id="targetIdMap.description.job.catchCopy"
            class="fwB margin-bottom-1 pega-pre-wrap"
            data-test="catch-copy"
            v-text="description.catchCopy"
          />
        </template>
      </job-preview-content>
    </job-preview-content-outline>

    <job-preview-content-outline
      v-if="description.workflow"
      title="一日の仕事の流れ"
      :comment-highlights="getCommentHighlights(targetIdMap.description.workflow)"
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      :text-counts="[getTextCount('一日の仕事の流れ', description.workflow, targetIdMap.description.workflow)]"
      :target-id="targetIdMap.description.workflow"
      :value="description.workflow"
      data-test="workflow"
      v-on="$listeners"
    />

    <job-preview-content-outline
      v-if="isShow.attentions"
      title="仕事の魅力"
      data-test="attentions"
      v-on="$listeners"
    >
      <job-preview-content
        v-for="(attention, key, index) in attentionsNotEmpty"
        :key="key"
        :comment-highlights="getAnyCommentHighlights(targetIdMap.description.attention.prefix, key)"
        :text-count-mode="textCountMode"
        :highlight-mode="highlightMode"
        :text-counts="textCounts.attention(key)"
        :target-id="`${targetIdMap.description.attention.text}-${key}`"
        :value="attention.text"
        :value-class="(index !== Object.keys(attentionsNotEmpty).length-1)?'mb15':''"
        :data-test="`attention-${key}`"
        v-on="$listeners"
      >
        <template #catch>
          <div class="mb5">
            <span
              class="point fs12"
              :data-test="`point-${key}`"
            >POINT0{{ key }}</span>
            <span
              :id="`${targetIdMap.description.attention.title}-${key}`"
              :data-test="`attention-title-${key}`"
              class="fwB"
              v-text="attention.title"
            />
          </div>
        </template>
      </job-preview-content>
    </job-preview-content-outline>

    <job-preview-content-outline
      v-if="isShow.improved"
      title="この仕事で磨ける経験・能力"
      :comment-highlights="getCommentHighlights(targetIdMap.description.improved)"
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      :text-counts="[getTextCount('この仕事で磨ける経験・能力', description.improved, targetIdMap.description.improved)]"
      :target-id="targetIdMap.description.improved"
      :value="description.improved"
      data-test="improved"
      v-on="$listeners"
    />

    <job-preview-content-outline
      v-if="isShow.strengths"
      title="アピールポイント"
      data-test="strengths"
      v-on="$listeners"
    >
      <job-preview-content
        v-for="(value, key, index) in strengthsNotEmpty"
        :key="key"
        :comment-highlights="getCommentHighlights(targetIdMap.description.strength[key])"
        :text-count-mode="textCountMode"
        :highlight-mode="highlightMode"
        :text-counts="[getTextCount(strengthTitle[key], description.strengths[key], targetIdMap.description.strength[key])]"
        :target-id="targetIdMap.description.strength[key]"
        :value="value"
        :value-class="(index !== Object.keys(strengthsNotEmpty).length-1)?'mb15':''"
        :data-test="`strength-${key}`"
        v-on="$listeners"
      >
        <template #catch>
          <div class="mb5">
            <span
              class="apoint fs12"
              :data-test="`strength-title-${key}`"
            >{{ strengthTitle[key] }}</span>
          </div>
        </template>
      </job-preview-content>
    </job-preview-content-outline>
  </article>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewContentOutline from '@/components/atoms/JobPreviewContentOutline'
import JobPreviewContent from '@/components/atoms/JobPreviewContent'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewHighlight from '@/lib/jobPreviewHighlight'

export default {
  components: {
    JobPreviewContentOutline,
    JobPreviewContent
  },
  mixins: [jobPreviewCommon, jobPreviewHighlight],
  props: {
    description: {
      type: Object,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      required: true
    },
    textCountMode: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      height: {
        job: { catchCopy: null }
      }
    }
  },
  computed: {
    descriptionMargin () {
      if (this.height.job.catchCopy) {
        return this.height.job.catchCopy - this.textCountHeight
      } else {
        return null
      }
    },
    textCounts () {
      return {
        job: [
          this.getTextCount('仕事内容キャッチ', this.description.catchCopy, this.targetIdMap.description.job.catchCopy),
          this.getTextCount('仕事内容本文', this.description.detail, this.targetIdMap.description.job.detail, this.tooltip.description, this.descriptionMargin)
        ],
        attention: (key) => {
          return [
            this.getTextCount(`POINT0${key}キャッチ`, this.description.attentions[key].title, this.targetIdMap.description.attention.title),
            this.getTextCount(`POINT0${key}本文`, this.description.attentions[key].text, this.targetIdMap.description.attention.text, this.tooltip.description)
          ]
        }
      }
    }
  },
  mounted () {
    const catchCopy = document.getElementById(this.targetIdMap.description.job.catchCopy)
    if (catchCopy) { this.$set(this.height.job, 'catchCopy', catchCopy.clientHeight) }
  }
}
</script>
